module.exports = __webpack_public_path__ + "static/media/optionsIntegrations.5bc901f2.png";